import {
  Instance,
  SnapshotOut,
  types,
  resolveIdentifier,
} from "mobx-state-tree";

import { ClassGroupRate, ClassGroupRateModel } from "./ClassGroupRate";
/**
 * Model description here for TypeScript hints.
 */
export const ClassGroupRateStoreModel = types
  .model("ClassGroupRateStore")
  .props({
    items: types.optional(types.array(ClassGroupRateModel), []),
  })
  .views((self) => ({})) // eslint-disable-line @typescript-eslint/no-unused-vars
  .actions((self) => ({
    addItem: (item: ClassGroupRate) => {
      if (resolveIdentifier(ClassGroupRateModel, self, item.id)) return;
      self.items.push(item);
    },
  }));
/**
  * Un-comment the following to omit model attributes from your snapshots (and from async storage).
  * Useful for sensitive data like passwords, or transitive state like whether a modal is open.

  * Note that you'll need to import `omit` from ramda, which is already included in the project!
  *  .postProcessSnapshot(omit(["password", "socialSecurityNumber", "creditCardNumber"]))
  */

type ClassGroupRateStoreType = Instance<typeof ClassGroupRateStoreModel>;
export type ClassGroupRateStore = ClassGroupRateStoreType;
type ClassGroupRateStoreSnapshotType = SnapshotOut<typeof ClassGroupRateStoreModel>;
export type ClassGroupRateStoreSnapshot = ClassGroupRateStoreSnapshotType;
